import React from "react";
import "./dashboardAppointmentsViewTableCell.scss";
import AppointmentsViewTableCell from "../../../../common/AppointmentsViewTableCell";

const DashboardAppointmentsViewTableCell = (props) => {
  // Display UI ===>

  const displayTableCell = () => {
    let currentAppointments = props?.appointmentsData?.filter(
      (appnt) => appnt.pageNo === Number(props.page_no)
    );
    return (
      <AppointmentsViewTableCell
        {...props}
        appointmentsData={currentAppointments}
      />
    );
  };

  // <===

  return <>{displayTableCell()}</>;
};

export default DashboardAppointmentsViewTableCell;
